export enum MyWorkItemType {
    ACTION_REQUIRED_TASK    = 'actionRequiredTask',
    ASSIGNED_TO_TASK        = 'assignedToTask',
    EVENT                   = 'event',
    MENTION                 = 'mention',
    MEETING                 = 'meeting',
    REMINDER                = 'reminder',
    REPORT                  = 'report',
    DEADLINE                = 'deadline',

    TODO                    = 'todo',

}

export const MY_WORK_ITEM_AR_TASK = MyWorkItemType.ACTION_REQUIRED_TASK
export const MY_WORK_ITEM_AS_TASK = MyWorkItemType.ASSIGNED_TO_TASK
export const MY_WORK_ITEM_EVENT = MyWorkItemType.EVENT
export const MY_WORK_ITEM_MENTION = MyWorkItemType.MENTION
export const MY_WORK_ITEM_MEETING = MyWorkItemType.MEETING
export const MY_WORK_ITEM_REMINDER = MyWorkItemType.REMINDER
export const MY_WORK_ITEM_REPORT = MyWorkItemType.REPORT
export const MY_WORK_ITEM_DEADLINE = MyWorkItemType.DEADLINE

export const MY_WORK_ALL_EVENTS = 'allEvents' // EVENT + DEADLINE
export const MY_WORK_ALL_REMINDERS = 'allReminders' // REMINDER + MENTION + REPORT

export const MY_WORK_ITEM_TYPES: any = {
    [MyWorkItemType.ACTION_REQUIRED_TASK]: {
        label: 'Action required',
        icon: 'i5-user'
    },
    [MyWorkItemType.ASSIGNED_TO_TASK]: {
        label: 'Assigned',
        icon: 'i5-user-assigned'
    },
    [MyWorkItemType.EVENT]: {
        label: 'Events',
        icon: 'i5-events-summary'
    },
    [MyWorkItemType.MENTION]: {
        label: 'Mentions',
        icon: ' i5-mention'
    },
    [MyWorkItemType.MEETING]: {
        label: 'Meetings',
        icon: 'i5-meeting'
    },
    [MyWorkItemType.REMINDER]: {
        label: 'Reminders',
        icon: 'i5-notification'
    },
    [MyWorkItemType.REPORT]: {
        label: 'Reports',
        icon: 'i5-reports'
    },
    [MyWorkItemType.DEADLINE]: {
        label: 'Task deadlines',
        icon: 'i5-deadline'
    },

    // not actual types just combined of previous
    [MY_WORK_ALL_EVENTS]: {
        label: 'Events',
        // icon: 'i5-events-summary'
    },
    [MY_WORK_ALL_REMINDERS]: {
        label: 'Reminders',
        // icon: 'i5-notification'
    },
    [MyWorkItemType.TODO]: {
        label: 'Todo items',
        icon: 'i5-todo'
    },
}
